var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.13,483.11c-8.61-1.16-17.27-1.99-25.81-3.54c-61.41-11.14-110.71-42-147.81-92.04 C48.6,353.92,34.13,315.96,30.1,274.35c-4.65-48.05,4.54-93.52,28.16-135.79c22.91-40.99,55.38-72.33,97.16-93.63 c12.14-6.19,25.1-11.19,38.2-14.98c12.84-3.72,25.18,2.81,32.24,14.62c6.18,10.32,4.78,25.21-3.16,34.91 c-4.47,5.46-10.26,8.75-16.79,11.03c-27.9,9.75-51.86,25.5-71.52,47.58c-23.33,26.22-37.43,56.72-41.79,91.63 c-5.31,42.41,4.11,81.49,28.04,116.64c24.88,36.53,59.25,60.24,102.48,70.06c46.33,10.53,89.87,2.78,129.84-22.91 c33.23-21.36,55.96-51.23,68.86-88.54c3.9-11.29,10.99-19.09,22.81-21.97c18.13-4.42,36.61,9.16,37.8,27.66 c0.1,1.59,0.44,3.17,0.67,4.76c0,0.3,0,0.59,0,0.89c-0.58,2.1-1.07,4.23-1.75,6.3c-5.99,18.17-13.93,35.44-24.17,51.6 c-22.05,34.81-51.18,62.12-87.51,81.6c-23.76,12.74-49.01,21.11-75.77,24.72c-7.3,0.98-14.63,1.72-21.94,2.57 C263.69,483.11,255.41,483.11,247.13,483.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.11,194.79c-2.27,4.55-3.78,9.73-6.94,13.54c-15.64,18.85-44.47,14.23-53.19-8.7c-6.86-18.05-14.86-35.34-26.64-50.75 c-20.26-26.5-45.93-45.64-77.24-57.22c-3.87-1.43-7.86-2.71-11.44-4.71c-14.2-7.93-19.42-24.99-12.58-40.33 c6.24-13.98,23.06-21.1,38.56-15.62c72.74,25.7,121.89,75.06,147.53,147.81c0.72,2.04,1.29,4.14,1.93,6.21 C483.11,188.28,483.11,191.53,483.11,194.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.11b096e5e46b04fa825de42ceaa0a5aa.svg";
export { ForwardRef as ReactComponent };